export var formatTime = function (date, locale) {
    return new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: 'numeric' }).format(date).replace(/ /g, '\xA0');
};
